import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { 
  browserTracingIntegration, 
  browserProfilingIntegration, 
} from "@sentry/react";
import { setupSessionInterceptors } from './utils/sessionManager';

// Setup session interceptors
setupSessionInterceptors();

// Initialize Sentry
Sentry.init({
  dsn: "https://ffe669e9e1e9a597b62e4822ed011b95@o4508971558633472.ingest.de.sentry.io/4510844902113360",
  integrations: [
    browserTracingIntegration({
      tracePropagationTargets: [
        "localhost", 
        /^https:\/\/your-api\.com/,
      ],
      shouldCreateSpanForRequest: (url) => {
        return !url.includes('sentry_key');
      },
    }),
    browserProfilingIntegration(),
  ],
  
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  profilesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  
  environment: process.env.NODE_ENV || 'development',
  release: `my-app@${process.env.REACT_APP_VERSION || 'unknown'}`,
  
  attachProps: true,
  normalizeDepth: 5,
});

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Caught error:', error, errorInfo);
    Sentry.captureException(error, { extra: { errorInfo } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontFamily: 'sans-serif'
        }}>
          <h2>Something went wrong.</h2>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#297934',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Wrap App with ErrorBoundary
const AppWithErrorBoundary = () => (
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

ReactDOM.render(
  <AppWithErrorBoundary />,
  document.getElementById('root')
);

reportWebVitals();